import { css, LayoutJay, styled } from "@lux/ds";
import { Verified } from "@lux/ds/Icon/MaterialIcons";

export const StyledLayoutJay = styled(LayoutJay)`
  flex: 1;
  justify-content: space-between;
`;

export const VerifiedIcon = styled(Verified)(
  ({ theme }) => css`
    align-self: center;
    color: ${theme.palette.success.dark};
    height: 16px;
    margin-left: -24px;
  `,
);
